import { closeCurrentModal } from 'weblite-web-modal-viewer'
import { Typography } from '@mui/material'
import { CompatibilityWarningLayout } from '$common/compatibility-warning-layout'
import { ArrowIOSIcon, NotifOffIcon } from '$common/icons'
import { WappPanel } from '$logic/wapp-panels'
import { t } from '$i18n'

// #moghavemat
export function NotifBlocked({ isOpen }: { isOpen: boolean }) {
  return (
    <CompatibilityWarningLayout
      isOpen={isOpen}
      icon={<NotifOffIcon sx={{ width: '64px', height: '64px' }} />}
      title={t('armanema.notifBlocked.title')}
      description={
        <Typography variant="paragraph1" textAlign="center">
          {t('armanema.notifBlocked.description')}
        </Typography>
      }
      onClose={closeCurrentModal}
      hideIconContainer
      onClick={() => {
        WappPanel.openWapp({
          wappId: 'neviseh-neviseh-main',
          input: {
            contentUri:
              'wappactivity://neviseh/1bf0d3cc-ccd7-4387-9499-b16378a763c4',
          },
        })
        closeCurrentModal()
      }}
      actionText={t('armanema.notifBlocked.button')}
      endIcon={<ArrowIOSIcon sx={{ color: 'neutral900' }} />}
    />
  )
}
